<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './assets/css/common.css'

export default {
    name: "App"
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
}
#app {
  font-family: "PingFang Medium";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
}
.m-form{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue